export default function () {
  window.onNuxtReady(() => {
      const link = document.createElement('link')
      link.rel = 'stylesheet'
      link.href = 'https://maxst.icons8.com/vue-static/landings/line-awesome/line-awesome/1.3.0/css/line-awesome.min.css'
      document.head.appendChild(link)
  })
}
